import styles from './styles.module.scss';
import { PropsWithChildren } from 'react';
import { LastMatchesContentProps } from './props';
import { useInfiniteScroll } from '@starsoft/common/hooks';

export default function LastMatchesContent({
  hasNextPage,
  isLoading,
  loadMore,
  children,
}: PropsWithChildren<LastMatchesContentProps>): JSX.Element {
  const { ref } = useInfiniteScroll({
    hasMore: hasNextPage,
    isLoading,
    loadMore,
  });

  return (
    <div className={styles.container} ref={ref}>
      {children}
    </div>
  );
}
